(function() {
  'use strict';

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lenisInstance = null;
  let rafId = null;
  let reducedMotionEnabled = reducedMotionQuery.matches;

  function loadLenisScript() {
    return new Promise(function(resolve, reject) {
      if (typeof window.Lenis !== 'undefined') {
        resolve();
        return;
      }

      const existingScript = document.querySelector('script[data-lenis-script="true"]');

      if (existingScript) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://unpkg.com/lenis@1.3.13/dist/lenis.min.js';
      script.async = true;
      script.dataset.lenisScript = 'true';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function stopRafLoop() {
    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function startRafLoop() {
    if (!lenisInstance || rafId) {
      return;
    }

    function raf(time) {
      if (!lenisInstance) {
        rafId = null;
        return;
      }

      lenisInstance.raf(time);
      rafId = window.requestAnimationFrame(raf);
    }

    rafId = window.requestAnimationFrame(raf);
  }

  function bindLenisControls() {
    document.querySelectorAll('[data-lenis-start]').forEach(function(element) {
      element.addEventListener('click', function() {
        if (lenisInstance) {
          lenisInstance.start();
        }
      });
    });

    document.querySelectorAll('[data-lenis-stop]').forEach(function(element) {
      element.addEventListener('click', function() {
        if (lenisInstance) {
          lenisInstance.stop();
        }
      });
    });

    document.querySelectorAll('[data-lenis-toggle]').forEach(function(element) {
      element.addEventListener('click', function() {
        this.classList.toggle('stop-scroll');

        if (!lenisInstance) {
          return;
        }

        if (this.classList.contains('stop-scroll')) {
          lenisInstance.stop();
        } else {
          lenisInstance.start();
        }
      });
    });
  }

  function destroyLenis() {
    stopRafLoop();

    if (lenisInstance) {
      lenisInstance.destroy();
      lenisInstance = null;
    }
  }

  function refreshScrollSystems() {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }
  }

  function createLenis() {
    if (reducedMotionEnabled || typeof window.Lenis === 'undefined') {
      destroyLenis();
      return;
    }

    destroyLenis();

    lenisInstance = new window.Lenis({
      lerp: 0.1,
      wheelMultiplier: 0.7,
      gestureOrientation: 'vertical',
      normalizeWheel: false,
      smoothTouch: false
    });

    window.lenis = lenisInstance;

    if (window.ScrollTrigger) {
      lenisInstance.on('scroll', function() {
        window.ScrollTrigger.update();
      });
    }

    startRafLoop();
    refreshScrollSystems();
  }

  function handleReducedMotionChange(event) {
    reducedMotionEnabled = event.matches;

    if (reducedMotionEnabled) {
      destroyLenis();
    } else {
      createLenis();
    }
  }

  async function initialiseLenis() {
    try {
      await loadLenisScript();
      createLenis();
      bindLenisControls();
    } catch (error) {
      console.error('Failed to initialise Lenis:', error);
    }
  }

  if (typeof reducedMotionQuery.addEventListener === 'function') {
    reducedMotionQuery.addEventListener('change', handleReducedMotionChange);
  } else if (typeof reducedMotionQuery.addListener === 'function') {
    reducedMotionQuery.addListener(handleReducedMotionChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseLenis);
  } else {
    initialiseLenis();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      refreshScrollSystems();
    });

    document.addEventListener('shopify:section:reorder', function() {
      refreshScrollSystems();
    });

    document.addEventListener('shopify:block:select', function() {
      refreshScrollSystems();
    });

    document.addEventListener('shopify:block:deselect', function() {
      refreshScrollSystems();
    });
  }

  window.addEventListener('load', function() {
    refreshScrollSystems();
  });

  window.addEventListener('resize', function() {
    refreshScrollSystems();
  });
})();